export default __webpack_public_path__ + "static/media/DINO.c46e8db0.png";